var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NameProfile'),_c('ProfessionalSummery'),_c('WorkExperience'),_c('SkillsSection'),_c('EducationDetails'),_c('AdditionalDetails')],1)}
var staticRenderFns = []

export { render, staticRenderFns }